import React from 'react';
import { motion } from 'framer-motion';
import { PillIcon, CalendarIcon, ClipboardCheckIcon, ShieldCheckIcon } from 'lucide-react';
const features = [{
  icon: PillIcon,
  title: 'Control de Medicamentos',
  description: 'Nombre, dosis, horario y notas de cada medicamento.'
}, {
  icon: CalendarIcon,
  title: 'Registro de Citas Médicas',
  description: 'Fecha, hora, doctor, motivo y preguntas para llevar.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Preparación para Consultas',
  description: 'Llega con preguntas y datos listos para aprovechar cada visita.'
}, {
  icon: ShieldCheckIcon,
  title: 'Listo para Urgencias',
  description: 'Todo a la mano en caso de visita inesperada o emergencia.'
}];
export function SolutionSection() {
  return <section className="bg-cream py-24 px-6 md:px-12 lg:px-24" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-91">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-92">
            ¿Qué es Checklist Vital?
          </h2>
          <p className="text-2xl text-navy/80 max-w-2xl mx-auto" data-id="element-93">
            Un formato diseñado específicamente para ayudarte a:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-94">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-warm border border-white hover:border-gold/30 transition-colors flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-95">
              <div className="bg-cream p-5 rounded-2xl flex-shrink-0" data-id="element-96">
                <feature.icon className="w-10 h-10 text-navy" data-id="element-97" />
              </div>
              <div data-id="element-98">
                <h3 className="text-2xl font-bold text-navy mb-3" data-id="element-99">
                  {feature.title}
                </h3>
                <p className="text-xl text-navy/70 leading-relaxed" data-id="element-100">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}